import { CookieKey } from './cookies/cookie-keys.const';
import { getCookie, setCookie } from './cookies/cookies';
import {
  getServerUrl,
  getAuthToken,
  getAuthTokenKey,
} from './environments.const';
import { SUPPORT_USER, SUPPORT_SESSION, inSupportMode, DEMO_SESSION, DEMO_USER, inDemoMode } from './remote-login';

const SERVER_URL: string = getServerUrl();
const AUTH_TOKEN: string = getAuthToken();
const FLEET_JWT: string | null = getCookie(CookieKey.FLEET_APP_CIAM_AUTH_TOKEN) || null;
const isInstallerWebview: boolean = !!FLEET_JWT && /#\/fleet-devices(\/|$)/.test(window.location.href);

let basicHeaders;
let supportModeHeaders = {};
let demoModeHeaders = {};

if (isInstallerWebview) {
  basicHeaders = { Authorization: `Bearer ${FLEET_JWT}` };
} else if (inDemoMode() || inSupportMode()) {
  basicHeaders = {
    'X-Web-User-Auth': getCookie(CookieKey.REMOTE_LOGIN_TOKEN),
  };
} else if (AUTH_TOKEN) {
  basicHeaders = {
    'X-Web-User-Auth': AUTH_TOKEN,
  };
}

if (inSupportMode()) {
  supportModeHeaders = {
    'X-Skip-User-Stats': 'true',
    'X-Hijacker': SUPPORT_USER,
    'X-Hijacker-Session': SUPPORT_SESSION,
  };
} else if (inDemoMode()) {
  demoModeHeaders = {
    'X-Skip-User-Stats': 'true',
    'X-Demo-User': DEMO_USER,
    'X-Demo-Session': DEMO_SESSION,
  };
}

export const defaultHeaders = Object.assign({}, basicHeaders, supportModeHeaders, demoModeHeaders);

export function isInstallerSession(): boolean {
  return isInstallerWebview;
}

export function overrideGeoTabAuthToken(authToken: string) {
  const domain: string = new URL(SERVER_URL)?.hostname;

  setCookie(getAuthTokenKey(), authToken, { path: '/', domain: `.${domain}`, sameSite: 'none', secure: true });
  defaultHeaders['X-Web-User-Auth'] = authToken;
}

export function overrideAuthToken(authToken: string) {
  setCookie(getAuthTokenKey(), authToken);
  defaultHeaders['X-Web-User-Auth'] = authToken;
}